module.exports = __webpack_public_path__ + "static/media/Simas.ab1c63ae.png";